import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

/**
 * Cliente da API de Mapeamento Job → Tabela do Tenant.
 * Endpoints servidos por `/jobs-erp/:id/mapeamento*` no backend.
 */
export default class JobMapeamentoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async obter(jobId) {
    try { return await this.api.get(`/jobs-erp/${jobId}/mapeamento`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async salvar(jobId, payload) {
    try { return await this.api.put(`/jobs-erp/${jobId}/mapeamento`, payload); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async excluir(jobId) {
    try { return await this.api.delete(`/jobs-erp/${jobId}/mapeamento`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async sugerir(jobId, body = {}) {
    try { return await this.api.post(`/jobs-erp/${jobId}/mapeamento/sugerir`, body); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async automapear(jobId, { tabela, campos_api }) {
    try { return await this.api.post(`/jobs-erp/${jobId}/mapeamento/automapear`, { tabela, campos_api }); }
    catch (err) { this.error.errorShow(err); throw err; }
  }
}
